module.exports = __webpack_public_path__ + "static/media/Wrap-up-01.7d21f4bd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/Wrap-up-01.mp3
// module id = 590
// module chunks = 0